












import { Component, Vue } from 'vue-property-decorator';
import { GitHistory } from '@/@types/LibraryComponent';
import GitHistoryCard from './GitHistoryCard.vue';

@Component({
  components: {
    GitHistoryCard,
  },
})
export default class GitHistoryList extends Vue {
  private histories: Array<
    GitHistory
  > = require('@/repository/mock/dummyData/git/gitHistoryList.json').histories;
}
